import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { recruitingHiringCriteriaCategoryQuerySchema } from './recruiting-hiring-criteria-category-query-schema';

export const recruitingHiringCriteriaCategoryFormSchema = recruitingHiringCriteriaCategoryQuerySchema
  .omit({ name: true, status: true })
  .extend({
    name: z.string().min(1),
    status: statusFormSchema,
  });

export type RecruitingHiringCriteriaCategoryFormSchema = z.infer<typeof recruitingHiringCriteriaCategoryFormSchema>;
